import IconeSemInformacaoIntimacao from '@/components/IconeSemInformacaoIntimacao';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { PlaylistAddCheck, Warning } from '@mui/icons-material';
import VistaMesa from '@mui/icons-material/LocalLibrary';
import IconeAnotacoes from '@mui/icons-material/Notes';
import { Checkbox, FormControlLabel, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import IconeDivergencia from '../IconeDivergencia';
import IconeOrigem from '../IconeOrigem';
import IconeRessalva from '../IconeRessalva';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import Apregoar from './Apregoar';
import IconeAdvogadoPreferencia from './icones/IconeAdvogadoPreferencia';
import IconeCorreJunto from './icones/IconeCorreJunto';
import IconeDestaque from './icones/IconeDestaque';
import IconeTipoJulgamento from './icones/IconeTipoJulgamento';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import PeticoesPendentes from './PeticoesPendentes';
import ResultadoJulgamento from './ResultadoJulgamento';
import StatusMinuta from './StatusMinuta';
import SustentacaoOral from './SustentacaoOral';
import VotoNaoLiberado from './VotoNaoLiberado';
import VotoRevogado from './VotoRevogado';
import { fontSize, lineHeight } from '@mui/system';

class CabecalhoProcessoOperacoesEmLotePartes extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            larguraPadraoIcones: computed,
            registro: computed,
            numeroProcesso: computed,
            partes: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get numeroProcesso() {
        return this.registro.processo.numeroCompleto;
    }

    get partes() {
        return this.observableProps.partes || [];
    }

    get origemPJe() {
        return this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    renderCheckbox() {
        return (
            <Table
                style={{
                    display: 'flex',
                    width: '300px'
                }}
            >
                <TableBody>
                    {this.partes.map((parte) => (
                        <TableRow key={this.numeroProcesso + '-' + parte.codigo}>
                            <TableCell sx={{ border: '0px' }}>
                                <FormControlLabel
                                    label={parte.nome}
                                    control={
                                        <Checkbox
                                            onClick={(evento) =>
                                                this.store.toggleCheckedOperacoesEmLotePartes(
                                                    this.numeroProcesso,
                                                    parte
                                                )
                                            }
                                            checked={this.store.isCheckedOperacoesEmLotePartes(
                                                this.numeroProcesso,
                                                parte
                                            )}
                                        />
                                    }
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    render() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', padding: '6px 0px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                        style={{
                            width: '350px',
                            marginRight: '8px',
                            cursor: this.observableProps.consulta ? 'default' : 'pointer'
                        }}
                    >
                        <LabelNumeroProcesso
                            habilitarCopiarNumero
                            registro={this.registro}
                        />
                    </span>
                </div>
                {this.renderCheckbox()}

                <div style={{ minWidth: this.observableProps.consulta ? '0px' : '320px' }}>
                    <IconesMagistradosProcesso registro={this.registro} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', minWidth: '60px' }}>
                    {this.origemPJe && (
                        <Tooltip title="Número de inclusão em pauta">
                            <Typography
                                variant="h6"
                                style={{ fontSize: '12pt', whiteSpace: 'nowrap', cursor: 'default' }}
                            >
                                {this.registro.informacoesAdicionais.NumeroPauta === '0'
                                    ? ''
                                    : this.registro.informacoesAdicionais.NumeroPauta}
                            </Typography>
                        </Tooltip>
                    )}
                </div>
                {this.renderAnotacoes()}
                {this.renderOrdenacaoSecretario()}
                <div
                    style={{
                        marginLeft: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: this.observableProps.consulta ? '0px' : '36px'
                    }}
                >
                    {this.parametroStore.isOrgaoTST && <IconeOrigem processo={this.registro.processo} />}
                </div>
                <Impedimento registro={this.registro} />
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <PeticoesPendentes registro={this.registro} />
                </div>
                <div
                    style={{
                        minWidth: this.larguraPadraoIcones,
                        marginLeft: this.margemPadraoIcones,
                        cursor: 'pointer '
                    }}
                >
                    <IconeTipoJulgamento registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <IconeCorreJunto processo={this.registro.processo} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeSemInformacaoIntimacao registro={this.registro} />
                </div>
                {this.registro.confirmadaInclusaoPauta && (
                    <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                        <Tooltip
                            title={'Inclusão confirmada em pauta/sessão'}
                            placement="top-start"
                        >
                            <PlaylistAddCheck style={{ width: '24px', height: '24px' }} />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }

    renderOrdenacaoSecretario() {
        return (
            <div>
                {this.parametroStore.isOrgaoTST && this.registro.sessaoId && (
                    <Tooltip title="Ordenação do Secretário">
                        <div
                            style={{
                                width: '65px',
                                minHeight: '30px',
                                padding: '5px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderRadius: '4px'
                            }}
                        >
                            {this.registro.informacaoProcessoSalaSessao.ordenacaoSecretario}
                        </div>
                    </Tooltip>
                )}
            </div>
        );
    }

    renderAnotacoes() {
        if (!this.registro?.sessaoId) {
            return null;
        }

        const possuiAnotacoes = this.registro.informacaoProcessoSalaSessao?.complementoAnotacoes && (
            <Tooltip title={'Anotações: ' + this.registro.informacaoProcessoSalaSessao.complementoAnotacoes}>
                <span>
                    <IconeAnotacoes style={{ fillOpacity: '0.4' }} />
                </span>
            </Tooltip>
        );

        return (
            <>
                <div style={{ marginLeft: '5px', minWidth: this.larguraPadraoIcones }}>{possuiAnotacoes}</div>
                <div style={{ marginRight: '8px' }}>
                    <Tooltip title="Anotação curta">
                        <div
                            style={{
                                width: '100px',
                                minHeight: '30px',
                                padding: '5px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderRadius: '4px'
                            }}
                        >
                            {this.registro.informacaoProcessoSalaSessao.anotacao}
                        </div>
                    </Tooltip>
                </div>
            </>
        );
    }

    get larguraPadraoIcones() {
        return this.observableProps.consulta ? '0px' : '30px';
    }

    get margemPadraoIcones() {
        return '4px';
    }
}

export default inject('stores')(observer(CabecalhoProcessoOperacoesEmLotePartes));
